[
    {
        "dayNum": "1",
        "date": "26",
        "superscript": "th",
        "month": "March"
    },
    {
        "dayNum": "2",
        "date": "27",
        "superscript": "th",
        "month": "March"
    },
    {
        "dayNum": "3",
        "date": "28",
        "superscript": "th",
        "month": "March"
    },
    {
        "dayNum": "4",
        "date": "2",
        "superscript": "nd",
        "month": "April"
    },
    {
        "dayNum": "5",
        "date": "3",
        "superscript": "rd",
        "month": "April"
    }
]